<button
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  type="button"
  class="flex flex-col items-start rounded-2xl border bg-neutral-0 px-3 py-1.5 text-left shadow-sm hover:border-primary-500"
  [class.border-neutral-300]="!cardOpen()"
  [class.border-primary-500]="cardOpen()"
  (click)="toggleCard()"
>
  <span class="text-sm font-medium">{{ "healthStatusCheck.label.heading" | translate }}</span>
  @if (nextScheduleDate(); as next) {
    <span class="text-xs text-neutral-300">{{ "healthStatusCheck.label.next" | translate }} {{ next | date: "dd.MM.yyyy" }}</span>
  } @else {
    <span class="text-xs text-neutral-300">{{ "healthStatusCheck.label.empty" | translate }}</span>
  }
</button>

@if (cardOpen()) {
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="cardOpen()"
    [cdkConnectedOverlayDisposeOnNavigation]="true"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayOffsetY]="8"
    (backdropClick)="closeCard()"
  >
    <mat-card>
      <mat-card-content class="w-[560px]">
        <div class="mb-4 flex items-center justify-between gap-2">
          <h4>{{ "healthStatusCheck.label.heading" | translate }}</h4>
          <div class="flex items-center gap-2">
            <button
              type="button"
              class="btn btn-primary px-3 py-1 text-sm"
              (click)="toggleAddForm()"
            >
              {{ "healthStatusCheck.action.add" | translate }}
            </button>
            <button
              type="button"
              class="flex items-center justify-center"
              (click)="closeCard()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        @if (lastSent(); as sent) {
          <div class="flex items-center justify-between py-1">
            <span class="text-sm text-neutral-300">{{ "healthStatusCheck.label.lastSent" | translate }}</span>
            <span class="text-sm">{{ sent.scheduledFor | date: "dd.MM.yyyy HH:mm" }}</span>
          </div>
        }

        @for (planned of plannedItems(); track planned.id) {
          <div class="flex items-center justify-between py-1">
            <span class="text-sm text-neutral-300">{{ "healthStatusCheck.label.planned" | translate }}</span>
            <div class="flex items-center gap-3">
              <span class="text-sm">{{ planned.scheduledFor | date: "dd.MM.yyyy HH:mm" }}</span>
              <button
                type="button"
                class="flex items-center justify-center text-warning-500"
                [attr.aria-label]="'healthStatusCheck.action.cancelPlanned' | translate"
                [disabled]="loading()"
                (click)="cancel(planned)"
              >
                <mat-icon>do_not_disturb</mat-icon>
              </button>
            </div>
          </div>
        }

        @if (!lastSent() && plannedItems().length === 0 && !addFormVisible()) {
          <div class="py-2 text-sm text-neutral-300">{{ "healthStatusCheck.label.empty" | translate }}</div>
        }

        @if (addFormVisible()) {
          <form
            class="mt-3 flex items-center gap-3"
            [formGroup]="scheduleForm"
            (ngSubmit)="submit()"
          >
            <span class="text-sm text-neutral-300">{{ "healthStatusCheck.label.scheduleNew" | translate }}</span>

            <shared-datepicker
              class="flex-1"
              formControlName="date"
              [errorKey]="undefined"
              [min]="minScheduleDate()"
            />

            <mat-form-field
              appearance="outline"
              class="w-28"
            >
              <input
                matInput
                formControlName="time"
                [matTimepicker]="timePicker"
              />
              <mat-timepicker #timePicker />
              <mat-timepicker-toggle
                matSuffix
                [for]="timePicker"
              />
            </mat-form-field>

            <button
              type="submit"
              class="btn btn-primary px-3 py-1 text-sm"
              [disabled]="scheduleForm.invalid || loading()"
            >
              {{ "healthStatusCheck.action.save" | translate }}
            </button>
          </form>

          @if (formErrorKey(); as key) {
            <div class="mt-1 text-xs text-error-600">{{ key | translate }}</div>
          }
        }

        @if (errorMessageKey(); as key) {
          <div class="mt-2 text-xs text-error-600">{{ key | translate }}</div>
        }
      </mat-card-content>
    </mat-card>
  </ng-template>
}
